module.exports = __webpack_public_path__ + "img/adddetail.65668751.svg";